import type { PriorityBucket } from 'shared/src/wrkthru/status-codes';

export type BucketMeta = {
  bucket: PriorityBucket;
  label: string;
  description: string;
  accent: {
    text: string;
    bg: string;
    border: string;
    hex: string;
    gradient: { from: string; to: string };
    /** Outer glow for the bar segment — P1 only (the operator's alarm signal). */
    glow?: string;
  };
};

export const BUCKETS: Record<PriorityBucket, BucketMeta> = {
  P1: {
    bucket: 'P1',
    label: 'Do Now',
    description: 'Critical issues — client delivery or major margin risk.',
    accent: {
      text: 'text-red-700',
      bg: 'bg-red-50',
      border: 'border-red-200',
      hex: '#dc2626',
      gradient: { from: '#f87171', to: '#b91c1c' },
      glow: '0 0 8px 0 #e11d48'
    }
  },
  P2: {
    bucket: 'P2',
    label: 'Needs Attention',
    description: 'Urgent — same-day action recommended.',
    accent: {
      text: 'text-amber-700',
      bg: 'bg-amber-50',
      border: 'border-amber-200',
      hex: '#d97706',
      gradient: { from: '#fbbf24', to: '#b45309' }
    }
  },
  P3: {
    bucket: 'P3',
    label: 'Review Next',
    description: 'Needs a decision — judgment call or stale-item review.',
    accent: {
      text: 'text-purple-700',
      bg: 'bg-purple-50',
      border: 'border-purple-200',
      hex: '#9333ea',
      gradient: { from: '#c084fc', to: '#7e22ce' }
    }
  },
  P4: {
    bucket: 'P4',
    label: 'Keep Watch',
    description: 'Routine confirmation or opportunity to capture.',
    accent: {
      text: 'text-blue-700',
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      hex: '#2563eb',
      gradient: { from: '#60a5fa', to: '#1d4ed8' }
    }
  },
  P5: {
    bucket: 'P5',
    label: 'No Action Needed',
    description: 'Healthy — all metrics within tolerance.',
    accent: {
      text: 'text-green-700',
      bg: 'bg-green-50',
      border: 'border-green-200',
      hex: '#16a34a',
      gradient: { from: '#4ade80', to: '#15803d' }
    }
  }
};

export const UNKNOWN_BUCKET_HEX = '#cbd5e1'; // slate-300
